module.exports = __webpack_public_path__ + "img/refresh.c10e9621.svg";